import _lib from '../_lib';
import {ReportNavigation,ReportsNavigation} from '@/store/modules/fsm/messages';
import { clearReport } from '@/mutation-types';
import active from './active/index';


export default ({tree,parent,api}) => {
  let regionName = 'reports';
  let activations = [
    {
      name: 'reports',
      test: api.messageIs(ReportsNavigation)
    },
    {
      name: 'report',
      test: api.messageIs(ReportNavigation)
    }
  ];
  let activeIndex = active;
  let readyToDormant = ({context}) => context.commit(`login/report/${clearReport}`,null,{root:true});
  let func = _lib({regionName,activations,activeIndex, readyToDormant });
  return func({tree,parent,api});
};
